import { Layout, Position as PositionComponent } from "components"
export const Position = () => {
 return (
  <Layout>
   <PositionComponent />
  </Layout>
 )
}
